




















import { Component, Vue } from "vue-property-decorator";
import { project } from "../board";
import { Action, State, Mutation } from "vuex-class";
import ProjectCard from "./ProjectCard.vue";

@Component({
  components: {
    ProjectCard,
  },
})
export default class Projects extends Vue {
  private newProjectName = "";
  @Action private getProjects;
  @Action createProject;
  @State projects: project[];

  public addNewProject() {
    if (this.newProjectName != "") {
      const newProject = {
        name: this.newProjectName,
        createdOn: new Date(),
        description: "",
      };
      this.createProject(newProject);
      this.newProjectName = "";
    }
  }

  public mounted() {
    this.getProjects();
  }
}
